import { get, post, put, deleteAll as _deleteAll, patch as _patch } from "./client";

function hasElements(array) {
    return array && Array.isArray(array) && array.length > 0;
}

function processError(error, callback) {
    const { response } = error;
    if (response && response.data) {
        callback(response.data);
    } else {
        callback("Network error!");
    }
}

export async function getAll({ url, onSuccess, onError, normalizer = (data) => data, data }) {
    try {
        const response = await get( data ? { url, data } : { url });
        if (response && hasElements(response.data)) {
            onSuccess(normalizer(response.data));
        } else {
            onSuccess([]);
        }
    } catch (error) {
        processError(error, onError);
    }
}

export async function getList({ url, data, onSuccess, onInfo, onError, normalizer = (data) => data }) {
    try {
        const response = await get({ url, data });
        const { data: responseData } = response || {};
        let newContent = [];
        let pageableData;
        if (responseData) {
            const { content, ...pageable } = responseData;
            if (hasElements(content)) {
                newContent = normalizer(content);
            }
            pageableData = pageable;
        }
        if (hasElements(newContent)) {
            onSuccess(newContent, pageableData);
        } else {
            onSuccess([]);
            onInfo("No results to display!", pageableData);
        }
    } catch (error) {
        processError(error, onError);
    }
}

export async function add({ url, data, onSuccess, onError }) {
    try {
        const response = await post({ url, data });
        onSuccess(response.data);
    } catch (error) {
        processError(error, onError);
    }
}

export async function addAsync({ url, data }) {
    try {
        return await post({ url, data });
    } catch (error) {
        throw error;
    }
}

export async function update({ url, data, onSuccess, onError }) {
    try {
        const response = await put({ url, data });
        onSuccess(response.data);
    } catch (error) {
        processError(error, onError);
    }
}

export async function updateAsync({ url, data }) {
    try {
        return await put({ url, data });
    } catch (error) {
        throw error;
    }
}

export async function deleteAll({ url, data, onSuccess, onError }) {
    try {
        const response = await _deleteAll({ url, data });
        onSuccess(response.data);
    } catch (error) {
        processError(error, onError);
    }
}

export async function deleteAllAsync({ url, data }) {
    try {
        return await _deleteAll({ url, data });
    } catch (error) {
        throw error;
    }
}

export async function getOneById({ url, onSuccess, onError, normalizer = (data) => data }) {
    try {
        const response = await get({ url });
        onSuccess(normalizer(response.data));
    } catch (error) {
        processError(error, onError);
    }
}

export async function getListAsync({ url, data, normalizer = (data) => data }) {
    try {
        const response = await get({ url, data });
        const { data: responseData } = response || {};
        let newContent = [];
        let pageableData;
        if (responseData) {
            const { content, ...pageable } = responseData;
            if (hasElements(content)) {
                newContent = normalizer(content);
            }
            pageableData = pageable;
        }
        return { data: newContent, pageableData };
    } catch (error) {
        return null;
    }
}

export async function getAsync({ url, normalizer = (data) => data, data }) {
    try {
        const response = await get({ url, data });
        return normalizer(response.data);
    } catch (error) {
        return null;
    }
}

export async function patch({ url, data, onSuccess, onError }) {
    try {
        const response = await _patch({ url, data });
        onSuccess(response.data);
    } catch (error) {
        processError(error, onError);
    }
}

export async function patchAsync({ url, data, config }) {
    try {
        return await _patch({ url, data, config });
    } catch (error) {
        throw error;
    }
}
